import { MintStatusModel } from '@arpeggi/shared/src/types'
import { styled } from '@stitches/react'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import ProfileRegistry from '../../../../stores/registry/ProfileRegistry'
import { Box } from '../../../core/Components'
import { SoundIcon } from '../../../core/icons'
import { gray2 } from '../../../platform/color'
import ActionsColumn from './ActionsColumn'
import DetailsColumn from './DetailsColumn'
import Row from './Row'
import Table from './Table'

const StyledIndexText = styled(Table.Text, {
  textAlign: 'right',
  left: '8px',
  width: '22px',
  position: 'absolute'
})
const IndexText = StyledIndexText

const MintInProgressRow: React.FC<{
  mintStatusEntity: MintStatusModel
  onClick: () => void
  songPreview: boolean
}> = ({ mintStatusEntity, onClick, songPreview }) => {
  const navigate = useNavigate()
  const artist = ProfileRegistry.getByIndexReactive(mintStatusEntity.user.walletAddress)
  const artistName = artist?.display_name

  return (
    <Row
      onClick={onClick}
      columns={{
        indicator: (
          <IndexText
            size={'14'}
            css={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            -
          </IndexText>
        ),
        avatar: (
          <Box
            css={{
              borderRadius: '50%',
              background: gray2,
              width: '26px',
              height: '26px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <SoundIcon width="20px" height="100%" />
          </Box>
        ),
        details: (
          <DetailsColumn
            title={mintStatusEntity.metadata.title}
            artistEthAddress={mintStatusEntity.user.walletAddress}
            artistName={artistName}
          />
        ),
        visualizer: <Table.Text bold>Mint in progress...</Table.Text>,
        genre: '-',
        remixCount: '-',
        actions: songPreview && (
          <ActionsColumn
            isDisabled
            handleMore={() => navigate(`/song-preview/${mintStatusEntity.jobId}`)}
          />
        )
      }}
    />
  )
}

export default observer(MintInProgressRow)
